module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('div', {
    staticClass: "filterbtns"
  }, [_vm._l((_vm.filter_areas), function(v, i) {
    return [_c('filterbtn', {
      attrs: {
        "active": (_vm.filter_area == v)
      },
      nativeOn: {
        "click": function($event) {
          _vm.filter_area = _vm.filter_areas[i]
        }
      }
    }, [_vm._v(_vm._s(v))])]
  })], 2), _vm._v(" "), (_vm.filter_area == 'boxes') ? [_c('box', {
    attrs: {
      "label": "Basic box"
    }
  }, [_vm._v("\n      Basic box\n    ")]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Basic box, meta content"
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [_vm._v("\n        [Meta-r]\n        "), _c('span', {
    staticClass: "textlink"
  }, [_vm._v("Link")]), _vm._v(" "), _c('span', {
    staticClass: "textlink"
  }, [_vm._v("Link")])]), _vm._v("\n      Basic box, meta content\n    ")], 2), _vm._v(" "), _c('box', {
    attrs: {
      "label": "box-ception",
      "open": _vm.boxOpenStatus1
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('boxOpenStatus1')
      }
    }
  }, [_c('box', {
    attrs: {
      "label": "box-ception",
      "open": _vm.boxOpenStatus2
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('boxOpenStatus2')
      }
    }
  }, [_c('box', {
    attrs: {
      "label": "box-ception",
      "open": _vm.boxOpenStatus3
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('boxOpenStatus3')
      }
    }
  }, [_vm._v("\n          open status handled with var and var update\n        ")])], 1)], 1), _vm._v(" "), _c('box', {
    attrs: {
      "label": "open = static non-var true",
      "open": true
    }
  }, [_vm._v("\n      open = static non-var true\n    ")]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "open = static non-var false",
      "open": false
    }
  }, [_vm._v("\n      open = static non-var false\n    ")]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Full header toggle-able",
      "open": false,
      "header-toggle": ""
    }
  }, [_vm._v("\n      Lorem ipsum dolor amet si\n    ")]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Only one box visible at a time",
      "open": true
    }
  }, [_c('box', {
    attrs: {
      "label": "Box 1",
      "open": _vm.boxOpenStatus_a1
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.setOnlyOneTrue(0, ['boxOpenStatus_a1', 'boxOpenStatus_a2', 'boxOpenStatus_a3'])
      }
    }
  }, [_vm._v("\n        Box 1\n      ")]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Box 2 (full header togglable)",
      "open": _vm.boxOpenStatus_a2,
      "header-toggle": ""
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.setOnlyOneTrue(1, ['boxOpenStatus_a1', 'boxOpenStatus_a2', 'boxOpenStatus_a3'])
      }
    }
  }, [_vm._v("\n        Box 2\n      ")]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Box 3",
      "open": _vm.boxOpenStatus_a3
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.setOnlyOneTrue(2, ['boxOpenStatus_a1', 'boxOpenStatus_a2', 'boxOpenStatus_a3'])
      }
    }
  }, [_vm._v("\n        Box 3\n      ")])], 1)] : _vm._e(), _vm._v(" "), (_vm.filter_area == 'tabs') ? [_c('box', {
    attrs: {
      "label": "Tabs"
    }
  }, [_c('tabs', {
    attrs: {
      "active-tab": _vm.tabs1_activeIndex
    }
  }, [_c('tab', {
    attrs: {
      "label": "First tab"
    }
  }, [_vm._v("\n            This is the content of the first tab\n        ")]), _vm._v(" "), _c('tab', {
    attrs: {
      "label": "Second tab"
    }
  }, [_vm._v("\n            This is the content of the second tab\n        ")]), _vm._v(" "), _c('tab', {
    attrs: {
      "label": "Custom fragment"
    }
  }, [_vm._v("\n            The fragment that is appended to the url can be customized\n        ")]), _vm._v(" "), _c('tab', {
    attrs: {
      "prefix": "X<span class='glyphicon glyphicon-star'></span>X ",
      "label": "Prefix and suffix",
      "suffix": " Y<span class='badge'>4</span>Y"
    }
  }, [_vm._v("\n            A prefix and a suffix can be added\n        ")])], 1)], 1), _vm._v(" "), _c('tabs', {
    attrs: {
      "look": "boxed",
      "active-tab": _vm.tabs1_activeIndex
    }
  }, [_c('tab', {
    attrs: {
      "label": "First tab"
    }
  }, [_vm._v("\n          This is the content of the first tab\n      ")]), _vm._v(" "), _c('tab', {
    attrs: {
      "label": "Second tab"
    }
  }, [_c('tabs', {
    attrs: {
      "look": "boxed",
      "active-tab": _vm.tabs1_activeIndex
    }
  }, [_c('tab', {
    attrs: {
      "label": "First tab"
    }
  }, [_vm._v("\n              This is the content of the first tab\n          ")]), _vm._v(" "), _c('tab', {
    attrs: {
      "label": "Second tab"
    }
  }, [_vm._v("\n              This is the content of the second tab\n          ")]), _vm._v(" "), _c('tab', {
    attrs: {
      "prefix": "X<span class='glyphicon glyphicon-star'></span>X ",
      "label": "Prefix and suffix",
      "suffix": " Y<span class='badge'>4</span>Y"
    }
  }, [_vm._v("\n              A prefix and a suffix can be added\n          ")])], 1)], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "prefix": "X<span class='glyphicon glyphicon-star'></span>X ",
      "label": "Prefix and suffix",
      "suffix": " Y<span class='badge'>4</span>Y"
    }
  }, [_vm._v("\n          A prefix and a suffix can be added\n      ")])], 1), _vm._v(" "), _c('TabBoxes', {
    attrs: {
      "tabs": [{
        label: 'tab1'
      }, {
        label: 'tab2'
      }]
    }
  }, [_c('template', {
    slot: "tab1"
  }, [_vm._v("Tab 1 her")]), _vm._v(" "), _c('template', {
    slot: "tab2"
  }, [_vm._v("Tab 2 her")])], 2)] : _vm._e(), _vm._v(" "), (_vm.filter_area == 'buttons') ? [_c('btn', [_vm._v("Btn color1")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Btn primary")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "secondary"
    }
  }, [_vm._v("Btn secondary")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "tertiary"
    }
  }, [_vm._v("Btn tertiary")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "danger"
    }
  }, [_vm._v("Btn danger")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("Btn warning")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("Btn success")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "primary",
      "disabled": ""
    }
  }, [_vm._v("Btn disabled")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Large and small"
    }
  }, [_c('btn', {
    attrs: {
      "color": "primary",
      "large": ""
    }
  }, [_vm._v("Large")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Normal")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "primary",
      "small": ""
    }
  }, [_vm._v("Small")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "filterbtns"
  }, [_vm._l((3), function(i) {
    return [_c('filterbtn', [_vm._v("Filterbtn")])]
  }), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": "true"
    }
  }, [_vm._v("Filterbtn")])], 2), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('btn', {
    attrs: {
      "icon-r": "Y"
    }
  }, [_vm._v("Button")]), _vm._v(" "), _c('btn', {
    attrs: {
      "icon-l": "X",
      "color": "secondary"
    }
  }, [_vm._v("Button")]), _vm._v(" "), _vm._v("\"\" icon-l=\"X\" color=\"secondary\">Button")] : _vm._e(), _vm._v(" "), (_vm.filter_area == 'interactions') ? [_c('box', {
    attrs: {
      "label": "Interactions"
    }
  }, [_c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.triggerToast()
      }
    }
  }, [_vm._v("Trigger toast")])], 1)] : _vm._e(), _vm._v(" "), (_vm.filter_area == 'inputs') ? [_c('box', {
    attrs: {
      "label": "Checkboxes"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkboxey12),
      expression: "checkboxey12"
    }],
    attrs: {
      "type": "checkbox",
      "id": "kj12b3kj"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkboxey12) ? _vm._i(_vm.checkboxey12, null) > -1 : (_vm.checkboxey12)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkboxey12,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkboxey12 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkboxey12 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkboxey12 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kj12b3kj"
    }
  }, [_vm._v("Label")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkboxey12),
      expression: "checkboxey12"
    }],
    attrs: {
      "type": "checkbox",
      "id": "kjh123"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkboxey12) ? _vm._i(_vm.checkboxey12, null) > -1 : (_vm.checkboxey12)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkboxey12,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkboxey12 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkboxey12 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkboxey12 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kjh123"
    }
  }, [_vm._v("Label")])])]), _vm._v(" "), _c('box', [_c('inputfield', {
    attrs: {
      "_label": "Timer",
      "suffix": "timer"
    }
  }, [_c('input', {
    staticClass: "number-btns",
    attrs: {
      "type": "number",
      "min": "0.25",
      "max": "3",
      "step": "0.25",
      "placeholder": "0"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Timer",
      "suffix": "xxx"
    }
  }, [_c('input', {
    staticClass: "number-btns",
    attrs: {
      "type": "number",
      "min": "0.25",
      "max": "3",
      "step": "0.25",
      "placeholder": "0"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Select box"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v("Vælg...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "a"
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "b"
    }
  }, [_vm._v("B")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "c"
    }
  }, [_vm._v("C")])]), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Med ikon",
      "icon": "linearicons/arrow-left"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Med ikon",
      "icon": "linearicons/alarm"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })])], 1)] : _vm._e(), _vm._v(" "), (_vm.filter_area == 'whatever') ? [_c('box', [_c('minidonut', {
    attrs: {
      "pct": 22,
      "color": 'white',
      "bgcolor": 'rgba(255,255,255,.3)'
    }
  }), _vm._v(" "), _c('minipctbar', {
    attrs: {
      "pct": 52,
      "color": 'white',
      "bgcolor": 'rgba(255,255,255,.3)'
    }
  }), _vm._v(" "), _c('minidonut', {
    attrs: {
      "pct": 36
    }
  }), _vm._v(" "), _c('minipctbar', {
    attrs: {
      "pct": 73
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, _vm._l((2), function(i) {
    return _c('div', {
      staticClass: "col m50"
    }, [_c('box', {
      attrs: {
        "label": "Box"
      }
    }, [_vm._v("Box")])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, _vm._l((5), function(i) {
    return _c('div', {
      staticClass: "col m20"
    }, [_c('box', {
      attrs: {
        "label": "Box"
      }
    }, [_vm._v("Box")])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, _vm._l((10), function(i) {
    return _c('div', {
      staticClass: "col m10"
    }, [_c('box', {
      attrs: {
        "label": "Box"
      }
    }, [_vm._v("Box")])], 1)
  }), 0), _vm._v(" "), _c('p', [_vm._v("Global data: Appname: " + _vm._s(_vm.globals.name) + ", " + _vm._s(_vm.globals.count) + " -\n  \t\t"), _c('span', {
    on: {
      "click": function($event) {
        return _vm.incrementGlobalCount()
      }
    }
  }, [_vm._v(_vm._s(_vm.globals.count))])]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Trend charts"
    }
  }, [_c('trend', {
    attrs: {
      "data": [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
      "gradient": ['#6fa8dc', '#42b983', '#2c3e50'],
      "auto-draw": "",
      "smooth": ""
    }
  })], 1), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Boxlabel"
    }
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.")]), _vm._v(" "), _c('btn', [_vm._v("Buttoner")])], 1), _vm._v(" "), _c('box', {
    attrs: {
      "label": "label here, yo"
    }
  }, [_vm._v("\n  \t\tYo, box indhold\n  \t\t"), _c('btn', [_vm._v("Yiffy")]), _vm._v(" "), _c('btn', [_vm._v("Yallo")])], 1), _vm._v(" "), _c('box', {
    attrs: {
      "label": "element-ui"
    }
  }), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Vue stuff to implement"
    }
  }, [_c('p', [_vm._v("Generic UI USE THIS !!!: https://josephuspaye.github.io/Keen-UI/#/ui-tabs")]), _vm._v(" "), _c('p', [_vm._v("Brug alt herfra, navnligt select")]), _vm._v(" "), _c('p', [_vm._v("Tooltips")]), _vm._v(" "), _c('p', [_vm._v("Alert/confirm/prompts")]), _vm._v(" "), _c('p', [_vm._v("Datatables: filter, pagination, sort, perpage")]), _vm._v(" "), _c('p', [_vm._v("https://github.com/surmon-china/vue-awesome-swiper")]), _vm._v(" "), _c('p', [_vm._v("Charts")]), _vm._v(" "), _c('p', [_vm._v("time/Date/calendarpicker")]), _vm._v(" "), _c('p', [_vm._v("Avatars")]), _vm._v(" "), _c('p', [_vm._v("Trello kanban: https://github.com/BrockReece/vue-kanban")]), _vm._v(" "), _c('p', [_vm._v("Wysiwyg")]), _vm._v(" "), _c('p', [_vm._v("Selectiz")]), _vm._v(" "), _c('p', [_vm._v("Colorpicker")])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bb2a655","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Kitchensink.vue
// module id = 599
// module chunks = 1